import styled from 'styled-components';
import { lineHeight } from '../style';

export const Label = styled.label`
  display: block;
  margin-bottom: ${0.5 * lineHeight}px;
`;
